const ISH_RAZORPAY_BASE = {
  timeout: 900,
  retry: { enabled: true, max_count: 3 },
  remember_customer: true,
  theme: { color: "#b9644a" },
} as const;

const ISH_RAZORPAY_ONE_TIME_METHODS = {
  method: { upi: true, card: true, netbanking: false, wallet: false, paylater: false },
  config: {
    display: {
      blocks: {
        ishvaram_recommended: {
          name: "Recommended",
          instruments: [{ method: "upi" }, { method: "card" }],
        },
      },
      sequence: ["block.ishvaram_recommended"],
      preferences: { show_default_blocks: true },
      hide: [{ method: "wallet" }, { method: "netbanking" }, { method: "paylater" }],
    },
  },
} as const;

export function buildIshvaramOneTimeRazorpayPolicy() {
  // Trailing revenue data: UPI + card carry captures; wallet/netbanking/paylater
  // add low-signal choice noise. Razorpay's documented display blocks let us
  // put UPI first while preserving card fallback and the SDK's mobile Intent /
  // desktop QR behavior. Keep one-time checkouts on the same policy so chat
  // reports and standalone reports cannot drift.
  return {
    ...ISH_RAZORPAY_BASE,
    ...ISH_RAZORPAY_ONE_TIME_METHODS,
  };
}

export function buildIshvaramRecurringRazorpayPolicy() {
  return ISH_RAZORPAY_BASE;
}
